export const getMinutesUntil = (date: Date, now: number): number =>
  Math.round((date.getTime() - now) / 60_000);
